import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable, switchMap } from "rxjs";
import { inject } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { cloneRequest } from "./jwt.interceptor.utils";
import { JwtService } from "../../services/auth/jwt.service";

export function jwtInterceptor(
	request: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
	const authService = inject(AuthService);
	const jwtService = inject(JwtService);

	const token = jwtService.getCurrentTokenId();
	const idExpired = token && jwtService.getTokenIdExpiration() < Date.now() / 1000 + 10;
	const accessExpired =
		jwtService.getCurrentAccessToken() &&
		jwtService.getAccessTokenExpiration() < Date.now() / 1000 + 10;

	if (accessExpired || idExpired) {
		return authService
			.refreshToken()
			.pipe(switchMap(refreshToken => next(cloneRequest(request, refreshToken))));
	} else if (token) {
		return next(cloneRequest(request, token));
	}

	return next(request);
}
